import React from 'react'
import Select, { mergeStyles } from 'react-select'
import { Control, Controller } from 'react-hook-form'

interface Props {
  type?: string
  placeholder?: string
  name: string
  label?: string
  defaultValue?: string
  error?: any
  control?: Control<any>
  required?: boolean | string
  options: Array<any>
  infoMessage?: JSX.Element | string
  isClearable?: boolean
  disabled?: boolean
  isSearchable?: boolean
  customStyles?: any
}

const SelectInput = (props: Props) => {
  const {
    name,
    label,
    control,
    required,
    options,
    isClearable,
    placeholder,
    disabled,
    isSearchable,
    infoMessage,
    customStyles,
  } = props
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: disabled ? false : required }}
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { error },
      }) => (
        <div className={`flex flex-1 flex-col font-Spartan`}>
          {label && (
            <label
              className={`block ${required && 'required'} ${
                error ? 'text-primary' : 'text-detailPrimary'
              } text-sm font-bold font-Karla mb-2`}
              htmlFor={name}>
              {label}
            </label>
          )}
          <Select
            value={value}
            id={'dealer_select'}
            classNamePrefix={'react-select'}
            isSearchable={isSearchable}
            isClearable={isClearable}
            components={{
              IndicatorSeparator: () => null,
            }}
            menuPlacement="auto"
            isDisabled={disabled}
            placeholder={placeholder}
            ref={ref}
            onChange={onChange}
            options={options}
            styles={mergeStyles(styles(error), customStyles)}
          />

          {error && !disabled && (
            <span
              className={
                'font-Spartan font-medium text-xs text-secondary-bittersweet-red'
              }>
              {error.message}
            </span>
          )}
        </div>
      )}
    />
  )
}

const styles = (error: any = undefined) => ({
  control: (base: any) => ({
    ...base,
    border: error ? '1px solid #FF6B6B' : 'none',
    // This line disable the blue border
    minWidth: 185,
    height: 32,
    minHeight: 32,
    fontFamily: 'Spartan',
    fontWeight: 'bold',
    fontSize: 12,
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
  }),
  valueContainer: (base: any) => ({
    ...base,
    height: 32,
  }),
  indicatorsContainer: (base: any) => ({
    ...base,
    height: 32,
  }),
  menu: (base: any) => ({
    ...base,
    width: 'max-content',
    minWidth: '100%',
    fontFamily: 'Spartan',
    fontWeight: 'bold',
    fontSize: 12,
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    color: '#09121F', // Custom colour
    marginTop: 0,
  }),

  clearIndicator: (base: any) => ({
    ...base,
    marginTop: 4,
    color: '#09121F',
  }),
})

export default SelectInput
